import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

function SupportPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Set the variable for articles page
    window.SB_ARTICLES_PAGE = true;

    // Load jQuery if not already loaded
    const jqueryScript = document.createElement('script');
    jqueryScript.src = 'https://soporte.cloudbaselatam.com/helpdesk/js/min/jquery.min.js';
    jqueryScript.async = true;
    document.body.appendChild(jqueryScript);

    // Load main script after jQuery
    jqueryScript.onload = () => {
      const mainScript = document.createElement('script');
      mainScript.id = 'sbinit';
      mainScript.src = 'https://soporte.cloudbaselatam.com/helpdesk/js/main.js';
      mainScript.async = true;
      document.body.appendChild(mainScript);
    };

    // Cleanup
    return () => {
      // Remove scripts on unmount
      const scripts = document.querySelectorAll('script[src*="cloudbaselatam.com"]');
      scripts.forEach(script => script.remove());
      
      // Remove the div content
      const articlesDiv = document.getElementById('sb-articles');
      if (articlesDiv) {
        articlesDiv.innerHTML = '';
      }
      
      // Clean up global variable
      delete window.SB_ARTICLES_PAGE;
    };
  }, []);

  return (
    <>
      <SEOHead
        title="Soporte - Cloudbase"
        description="Centro de ayuda y soporte de Cloudbase. Encuentra respuestas, tutoriales y documentación."
        keywords="soporte cloudbase, ayuda, documentación, tutoriales"
      />
      <div className="min-h-screen bg-white">
        <Header />

        {/* Hero Section */}
        <section className="pt-32 pb-12 bg-gradient-to-br from-gray-900 via-gray-800 to-black">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-white">
                Centro de Ayuda
              </h1>
              <p className="text-xl text-gray-300">
                Encuentra respuestas, tutoriales y documentación para aprovechar al máximo Cloudbase
              </p>
            </div>
          </div>
        </section>

        {/* Support Content Section */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
              {/* Embedded Support Widget */}
              <div id="sb-articles" className="sb-loading min-h-screen"></div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}

export default SupportPage;